/**
 * Lightweight conversion hooks — pushes to dataLayer / gtag / Shopify analytics when present.
 * Does not collect private artwork filenames or form field values.
 */
(function () {
  'use strict';
  if (window.__CH_ANALYTICS_LOADED) return;
  window.__CH_ANALYTICS_LOADED = true;

  function track(eventName, detail) {
    if (!eventName) return;
    var payload = detail || {};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName, ch_event: eventName }, payload));
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
      }
    } catch (e2) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, payload);
      }
    } catch (e3) {}
  }

  document.addEventListener(
    'click',
    function (e) {
      var el = e.target.closest('[data-ch-event]');
      if (!el) return;
      track(el.getAttribute('data-ch-event'), { link_text: (el.textContent || '').trim().slice(0, 80) });
    },
    true
  );

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el && el.matches('input[type="file"][data-ch-event]')) {
      track(el.getAttribute('data-ch-event'), { file_count: el.files ? el.files.length : 0 });
    }
  });

  var orderForm = document.getElementById('CHOrderForm');
  if (orderForm) {
    orderForm.addEventListener('focusin', function once() {
      track('quote_form_start');
      orderForm.removeEventListener('focusin', once);
    });
  }

  if (document.body && document.body.classList.contains('template-product')) {
    track('product_view');
  }
})();
